// extracted by mini-css-extract-plugin
export default {"Container":"ErrorPage_Container__8ccWA","HeadingText":"ErrorPage_HeadingText__i94vt","SubText":"ErrorPage_SubText__0wbz1","Image":"ErrorPage_Image__w7AXE"};